<template>
  <div class="flex flex-col gap-4">
    <div class="flex-row flex justify-between">
      <titlePrimary :title="$t('user.detail.title')" class="px-8" />
      <div class="flex flex-row gap-4">
        <!-- <RouterLink
          :to="{ path: '/new-user', query: { id: id, action: 'password' } }"
        >
          <ButtonWhite>{{ $t('user.buttons.changePassword') }}</ButtonWhite>
        </RouterLink> -->
        <RouterLink
          v-if="canManage"
          :to="{ path: '/user-new', query: { id: id, action: 'edit' } }"
        >
          <ButtonWhite>{{ $t('user.buttons.edit') }}</ButtonWhite>
        </RouterLink>

        <ButtonWhite v-if="canManage" @click="confirmAndSendSetPassword" class="bg-white" :title="$t('admin.buttons.changePassword') || 'Cambiar contraseña'">
          {{ $t('admin.buttons.changePassword') || 'Cambiar contraseña' }}
        </ButtonWhite>

        <ButtonWhite
        v-if="canChangeStatus"
        @click="openStatusModal"
        >{{ isInactive ? $t('user.buttons.activate') : $t('user.buttons.deactivate') }}</ButtonWhite>
      </div>
    </div>

    <div v-if="loading" class="text-center p-4">
      {{ $t('common.loading') }}
    </div>
    <div v-else-if="error" class="text-red-500 text-center p-4">
      {{ error }}
    </div>

    <div v-else-if="supplysData" class="contents">
      <div class="grid grid-cols-1 md:grid-cols-2 gap-0 p-3 rounded-xl border shadow-lg bg-white">
        <!-- - - - - Información Personal - - - - - -->
        <inputPrimary
          :modelValue="companyName"
          :label="$t('user.new.fields.admin') + ':'"
          :placeholder="$t('user.new.placeholders.admin')"
          :readonly="isReadOnly"
          class="p-3"
        ></inputPrimary>
        <!-- El nombre de la firma va arriba; aquí la persona de contacto, que
             la migración separa en `contact_name`. -->
        <inputPrimary
          :modelValue="supplysData.contact_name ?? supplysData.name ?? '-'"
          :label="$t('user.fields.name') + ':'"
          :placeholder="$t('user.new.placeholders.name')"
          :readonly="isReadOnly"
          class="p-3"
        ></inputPrimary>

        <!-- El personal de ADS no tiene CIF: su ficha muestra su DNI/CIF/NIE y
             su perfil, que solo modifica el superadministrador (ADSREC-0008). -->
        <template v-if="isAdsStaffTarget">
          <inputPrimary
            :modelValue="supplysData.dni_nie || '-'"
            :label="$t('admin.form.labels.identityDocument') + ':'"
            :readonly="isReadOnly"
            class="p-3"
          ></inputPrimary>
          <inputPrimary
            :modelValue="staffProfile"
            :label="$t('user.fields.accounttype') + ':'"
            :readonly="isReadOnly"
            class="p-3"
          ></inputPrimary>
        </template>
        <inputPrimary
          v-else
          :modelValue="supplysData.cif ?? '-'"
          :label="$t('user.fields.cif') + ':'"
          :readonly="isReadOnly"
          class="p-3"
        ></inputPrimary>

        <inputPrimary
          :modelValue="supplysData.telephone ?? supplysData.mobile ?? '-'"
          :label="$t('user.fields.phone') + ':'"
          :placeholder="$t('user.new.placeholders.phone')"
          :readonly="isReadOnly"
          class="p-3"
        ></inputPrimary>

        <inputPrimary
          :modelValue="supplysData.email ?? '-'"
          :label="$t('user.fields.email') + ':'"
          :placeholder="$t('user.new.placeholders.email')"
          :readonly="isReadOnly"
          class="p-3"
        ></inputPrimary>

        <!-- - - - - Tipo de Cuenta - - - - -->
        <!-- <inputPrimary
          :modelValue="getAccountType()"
          :label="$t('user.fields.accounttype') + ':'"
          class="p-3"
        ></inputPrimary> -->

        <!-- - - - - - Estado y Notificaciones - - - - - -->
        <inputPrimary
          :modelValue="$t(`user.status.${supplysData.status?.toLowerCase()}`) || '-'"
          :label="$t('user.fields.status') + ':'"
          :readonly="isReadOnly"
          class="p-3"
        ></inputPrimary>

        <inputPrimary
          :modelValue="supplysData.has_notifications == 1 ? $t('common.yes') : $t('common.no')"
          :label="$t('user.fields.notifications') + ':'"
          :readonly="isReadOnly"
          class="p-3"
        ></inputPrimary>

        <inputPrimary
          :modelValue="supplysData.sees_all_requests ? $t('common.yes') : $t('common.no')"
          :label="$t('user.fields.seesAllRequests') + ':'"
          :readonly="isReadOnly"
          class="p-3"
        ></inputPrimary>

        <!-- Información Bancaria y Fiscal -->
        <!-- <inputPrimary
          :modelValue="supplysData.iban ?? '-'"
          :label="$t('user.fields.iban') + ':'"
          class="p-3"
        ></inputPrimary> -->

        <!-- <inputPrimary
          :modelValue="supplysData.cif ?? '-'"
          :label="$t('user.fields.cif') + ':'"
          class="p-3"
        ></inputPrimary> -->

        <!-- - - - - -  Información de Contrato - - - - - - - -->
        <!-- <inputPrimary
          :modelValue="supplysData.contract_data ?? '-'"
          :label="$t('user.fields.contract_data') + ':'"
          class="p-3"
        ></inputPrimary> -->

        <!-- <inputPrimary
          :modelValue="supplysData.maintenance == 1 ? $t('common.yes') : $t('common.no')"
          :label="$t('user.fields.maintenance') + ':'"
          class="p-3"
        ></inputPrimary> -->

        <!-- - - - - -  Dirección - - - - - -->
        <!-- <inputPrimary
          :modelValue="supplysData.address ?? '-'"
          :label="$t('user.fields.address') + ':'"
          class="p-3"
        ></inputPrimary>

        <inputPrimary
          :modelValue="supplysData.postal_code ?? '-'"
          :label="$t('user.fields.postal_code') + ':'"
          class="p-3"
        ></inputPrimary>

        <inputPrimary
          :modelValue="supplysData.city ?? '-'"
          :label="$t('user.fields.city') + ':'"
          class="p-3"
        ></inputPrimary>

        <inputPrimary
          :modelValue="supplysData.state ?? '-'"
          :label="$t('user.fields.state') + ':'"
          class="p-3"
        ></inputPrimary> -->

        <!-- - - - - - - Información Comercial - - - - - - -->
        <!-- <inputPrimary
          :modelValue="supplysData.commercial ?? '-'"
          :label="$t('user.fields.commercial') + ':'"
          class="p-3"
        ></inputPrimary> -->

        <!-- - - - - - - Nombre de la empresa - - - - - - -->
        <!-- <inputPrimary
          :modelValue="supplysData.company_name ?? '-'"
          :label="$t('user.fields.companyName') + ':'"
          class="p-3"
        ></inputPrimary> -->

        <!-- - - - - - - CP - - - - - - -->
        <!-- <inputPrimary
          :modelValue="supplysData.cp ?? '-'"
          :label="$t('user.fields.cp') + ':'"
          class="p-3"
        ></inputPrimary> -->

        <!-- - - - - - - Comercial asignado con botón de edición - - - - - - -->
        <!-- <div class="p-3">
          <label class="text-[#385660] font-medium block mb-2" style="font-size: 16px;">
            {{ $t('user.fields.assignedCommercial') + ':' }}
          </label>
          <div class="flex items-center border border-[#3A5762] rounded-lg px-3 shadow-[0px_4px_4px_0px_rgba(0,0,0,0.25)] bg-[#F5F5F5]">
            <input
              type="text"
              class="flex-1 py-2 h-10 text-sm border-none outline-none text-[#9E9E9E] bg-transparent cursor-not-allowed"
              style="font-size: 14px;"
              :value="supplysData.commercial || '-'"
              disabled
            />
            <button 
              @click="openCommercialSearchModal"
              class="p-1 hover:bg-gray-100 rounded transition-colors flex-shrink-0"
              :title="$t('user.actions.editCommercial')"
            >
              <svg class="w-4 h-4 text-[#385660] hover:text-[#2AB4D9]" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M15.232 5.232l3.536 3.536m-2.036-5.036a2.5 2.5 0 113.536 3.536L6.5 21.036H3v-3.572L16.732 3.732z" />
              </svg>
            </button>
          </div>
        </div> -->

        <!-- - - - - - - Nombre del contacto - - - - - - -->
        <!-- <inputPrimary
          :modelValue="supplysData.contact_name ?? '-'"
          :label="$t('user.fields.contactName') + ':'"
          class="p-3"
        ></inputPrimary> -->

        <!-- - - - - - - Observaciones - - - - - - -->
        <textareaPrimary
          :modelValue="supplysData.observations ?? '-'"
          :label="$t('user.fields.observations') + ':'"
          class="md:col-span-2 p-3"
          :rows="3"
          :readonly="isReadOnly"
        ></textareaPrimary>
      </div>
    </div>

    <!-- - - - - - - - Comunidades - - - - - - - - -->
    <!-- Asociar/desasociar comunidades es un control interno de ADS: los
         clientes (horizontal, vertical, both) no deben verlo (SOL-08). -->
    <template v-if="isAdsUser">
    <titlePrimary :title="$t('user.properties.title')" class="px-8" />
    <div class="rounded-xl border shadow-[0px_4px_4px_0px_rgba(0,0,0,0.25)] p-4">
      <p v-if="propertiesError" role="alert" class="text-red-500 text-center pb-4">{{ propertiesError }}</p>
      <div class="flex flex-row gap-4">
        <div class="flex flex-col w-1/2 gap-4">
          <div class="flex flex-row justify-between px-4">
            <h2>{{ $t('user.properties.associated') }}</h2>
            <ButtonWhite @click="desociar">{{ $t('user.buttons.unlink') }}</ButtonWhite>
          </div>

          <SearchPrimary
            ref="searchAsociadasRef"
            :icon="SearchIcon"
            :selectFilterName="fields"
            :searchEndpoint="searchEndpointAsociadas"
            :perPage="10"
            :extraParams="associationParams"
            @search-results="handleSearchResults('associate', $event)"
            @search-error="handleSearchError"
            @reset-search="() => resetSearch('associate')"
            @update:selectedFilter="handleSelectedFilter"
            @update-page="handlePageUpdateAsociadas"
          />

          <div class="p-4 border rounded-xl">
            <div v-if="loading">
              <p class="text-center">{{ $t('common.loading') }}</p>
            </div>
            <div v-else-if="error">
              <p class="text-center text-red-500">{{ error }}</p>
            </div>
            <div v-else>
              <div v-for="item in fincaData.associate" :key="item.id" class="mb-2">
                <label class="flex items-center gap-2">
                  <input type="checkbox" :value="item.id" v-model="selectedIds" />
                  <span>{{ item.name }}</span>
                  <RouterLink
                    :to="{ name: 'Property-detail', params: { id: item.id } }"
                    class="text-[#385660] hover:text-[#2AB4D9] transition-colors"
                  >
                    <svg class="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
                      <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M10 6H6a2 2 0 00-2 2v10a2 2 0 002 2h10a2 2 0 002-2v-4M14 4h6m0 0v6m0-6L10 14" />
                    </svg>
                  </RouterLink>
                </label>
              </div>
            </div>
          </div>

          <PaginateComponent
            :totalPages="totalPagesAsociadas" :paginationInfo="paginationInfoAsociadas"
            :modelValue="currentPageAsociadas"
            @update:modelValue="handlePageChangeAsociadas"
          />
        </div>

        <div class="flex flex-col w-1/2 gap-4">
          <div class="flex flex-row justify-between px-4">
            <h2>{{ $t('user.properties.toAssociate') }}</h2>
            <ButtonWhite @click="asociar">{{ $t('user.buttons.link') }}</ButtonWhite>
          </div>

          <SearchPrimary
            ref="searchDesasociadasRef"
            :icon="SearchIcon"
            :selectFilterName="fields"
            :searchEndpoint="searchEndpointDesasociadas"
            :perPage="10"
            :extraParams="associationParams"
            @search-results="handleSearchResults('disassociate', $event)"
            @search-error="handleSearchError"
            @reset-search="() => resetSearch('disassociate')"
            @update:selectedFilter="handleSelectedFilter"
            @update-page="handlePageUpdateDesasociadas"
          />

          <div class="p-4 border rounded-xl">
            <div v-if="loading">
              <p class="text-center">{{ $t('common.loading') }}</p>
            </div>
            <div v-else-if="error">
              <p class="text-center text-red-500">{{ error }}</p>
            </div>
            <div v-else>
              <div v-for="item in fincaData.disassociate" :key="item.id" class="mb-2">
                <label class="flex items-center gap-2">
                  <input type="checkbox" :value="item.id" v-model="selectedIds" />
                  <span>{{ item.name }}</span>
                  <RouterLink
                    :to="{ name: 'Property-detail', params: { id: item.id } }"
                    class="text-[#2AB4D9] transition-colors"
                  >
                    <svg class="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
                      <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M10 6H6a2 2 0 00-2 2v10a2 2 0 002 2h10a2 2 0 002-2v-4M14 4h6m0 0v6m0-6L10 14" />
                    </svg>
                  </RouterLink>
                </label>
              </div>
            </div>
          </div>

          <PaginateComponent
            :totalPages="totalPagesDesasociadas" :paginationInfo="paginationInfoDesasociadas"
            :modelValue="currentPageDesasociadas"
            @update:modelValue="handlePageChangeDesasociadas"
          />
        </div>
      </div>
    </div>
    </template>

    <!-- Commercial Search Modal -->
    <div v-if="showCommercialSearchModal" class="fixed inset-0 bg-black/50 flex items-center justify-center z-50">
      <div class="bg-white rounded-xl shadow-lg w-full max-w-md mx-4 max-h-[80vh] flex flex-col">
        <!-- Header -->
        <div class="flex items-center justify-between p-6 border-b">
          <h3 class="text-lg font-semibold text-[#385660]">{{ $t('user.modalCommercialSearch.title') }}</h3>
          <button @click="closeCommercialSearchModal" class="text-gray-400 hover:text-gray-600 transition-colors">
            <svg class="w-6 h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M6 18L18 6M6 6l12 12"></path>
            </svg>
          </button>
        </div>

        <!-- Search Input -->
        <div class="p-6 border-b">
          <div class="relative">
            <input 
              v-model="commercialSearchQuery" 
              @input="searchCommercials" 
              type="text"
              :placeholder="$t('user.modalCommercialSearch.searchPlaceholder')"
              :readonly="isReadOnly"
              class="w-full px-4 py-3 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-[#2AB4D9] focus:border-transparent" 
            />
            <div v-if="isSearchingCommercials" class="absolute right-3 top-1/2 transform -translate-y-1/2">
              <div class="animate-spin rounded-full h-5 w-5 border-b-2 border-[#2AB4D9]"></div>
            </div>
          </div>
        </div>

        <!-- Commercial List -->
        <div class="flex-1 overflow-y-auto p-6">
          <div v-if="isSearchingCommercials && !searchedCommercials.length" class="text-center py-8 text-gray-500">
            {{ $t('user.modalCommercialSearch.searching') }}
          </div>
          <div v-else-if="!isSearchingCommercials && !searchedCommercials.length && commercialSearchQuery"
            class="text-center py-8 text-gray-500">
            {{ $t('user.modalCommercialSearch.noResults') }}
          </div>
          <div v-else-if="!commercialSearchQuery" class="text-center py-8 text-gray-500">
            {{ $t('user.modalCommercialSearch.startTyping') }}
          </div>
          <div v-else class="space-y-2">
            <button 
              v-for="commercial in searchedCommercials" 
              :key="commercial.id" 
              @click="selectCommercial(commercial)"
              class="w-full text-left p-3 rounded-lg border border-gray-200 hover:bg-gray-50 hover:border-[#2AB4D9] transition-colors"
            >
              <div class="font-medium text-[#385660]">{{ [commercial.name, commercial.surname].filter(Boolean).join(' ') }}</div>
              <div v-if="commercial.email" class="text-sm text-gray-500">{{ commercial.email }}</div>
            </button>
          </div>
        </div>

        <!-- Footer -->
        <div class="p-6 border-t flex justify-end space-x-3">
          <button 
            @click="closeCommercialSearchModal"
            class="px-4 py-2 text-gray-600 border border-gray-300 rounded-lg hover:bg-gray-50 transition-colors"
          >
            {{ $t('user.modalCommercialSearch.cancel') }}
          </button>
        </div>
      </div>
    </div>

    <!-- Activate/deactivate confirmation modal -->
    <div v-if="showStatusModal" class="fixed inset-0 bg-black/50 flex items-center justify-center z-50">
      <div class="bg-white rounded-xl shadow-lg w-full max-w-lg mx-4 max-h-[80vh] flex flex-col">
        <div class="flex items-center justify-between p-6 border-b">
          <h3 class="text-lg font-semibold text-[#385660]">
            {{ isInactive ? $t('user.statusAction.activateTitle') : $t('user.statusAction.deactivateTitle') }}
          </h3>
          <button @click="closeStatusModal" class="text-gray-400 hover:text-gray-600 transition-colors">
            <svg class="w-6 h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M6 18L18 6M6 6l12 12"></path>
            </svg>
          </button>
        </div>

        <div class="p-6 flex-1 overflow-y-auto">
          <p>{{ isInactive ? $t('user.statusAction.confirmActivate') : $t('user.statusAction.confirmDeactivate') }}</p>
          <div v-if="requiresPrimaryTransfer" class="mt-5 space-y-4">
            <p class="font-semibold text-[#385660]">{{ $t('user.statusAction.transferTitle') }}</p>
            <div v-for="account in primaryAccounts" :key="account.id" class="space-y-2">
              <label :for="`primary-transfer-${account.id}`" class="block text-sm text-[#385660]">
                {{ account.name }}
              </label>
              <select
                :id="`primary-transfer-${account.id}`"
                v-model.number="selectedReplacements[account.id]"
                class="w-full rounded-lg border border-gray-300 bg-white px-3 py-2 text-[#385660]"
                :disabled="loadingTransferOptions"
              >
                <option :value="null">{{ $t('user.statusAction.selectReplacement') }}</option>
                <option v-for="candidate in transferOptions[account.id] || []" :key="candidate.id" :value="candidate.id">
                  {{ [candidate.name, candidate.surname].filter(Boolean).join(' ') || candidate.email }}
                </option>
              </select>
              <p v-if="!loadingTransferOptions && !(transferOptions[account.id] || []).length" class="text-sm text-red-600">
                {{ $t('user.statusAction.noReplacement') }}
              </p>
            </div>
          </div>
          <div v-if="statusError" class="text-red-500 mt-3">{{ statusError }}</div>
        </div>

        <div class="p-6 border-t flex justify-end space-x-3">
          <button @click="closeStatusModal" class="px-4 py-2 text-gray-600 border border-gray-300 rounded-lg hover:bg-gray-50 transition-colors">
            {{ $t('user.statusAction.cancel') }}
          </button>
          <button @click="confirmStatusChange" :disabled="isChangingStatus || loadingTransferOptions || !transfersComplete" class="px-4 py-2 bg-[#2AB4D9] text-white rounded-lg hover:opacity-90 disabled:opacity-50">
            <span v-if="!isChangingStatus">{{ isInactive ? $t('user.buttons.activate') : $t('user.buttons.deactivate') }}</span>
            <span v-else>{{ $t('user.statusAction.changing') }}</span>
          </button>
        </div>
      </div>
    </div>

  </div>
</template>

<script setup>
import { ref, computed, onMounted } from "vue";
import { useI18n } from 'vue-i18n';
import axios from "axios";
import { useRoute } from "vue-router";
import { toast } from 'vue3-toastify';
import titlePrimary from "@/components/title/title-primary.vue";
import InputPrimary from "@/components/inputs/input-primary.vue";
import textareaPrimary from "@/components/inputs/textarea-primary.vue";
import ButtonWhite from "@/components/button/ButtonWhite.vue";
import SearchPrimary from "@/components/search/search-primary.vue";
import PaginateComponent from "@/components/paginate/PaginateComponent.vue";
import { usePaginationInfo } from "@/composables/usePaginationInfo";
import ButtonComponent from "@/components/button/button-component.vue";
import { accountTypeLabel } from "@/services/clientAccount";
import { hasAnyRole, isBackOffice } from "@/services/userRoles";
import { isAdsUser as checkIsAdsUser } from "@/services/userRoles";


// --- State ---
const route = useRoute();
const id = route.params.id;
// Solo el personal ADS ve y carga el bloque de comunidades asociadas.
const isAdsUser = checkIsAdsUser();
// El detalle se abre con el id de una cuenta cliente o de una persona. Las
// comunidades pertenecen a la cuenta, así que el backend necesita saber a cuál
// de las dos cosas apunta el id (account_id / user_id).
const targetKind = ref(null);
const associationParams = computed(() =>
  targetKind.value === 'account' ? { account_id: Number(id) } : { user_id: Number(id) }
);
const supplysData = ref(null);
const { t } = useI18n();
const fincaData = ref({ associate: [], disassociate: [] });
const loading = ref(true);
const error = ref(null);
const currentPageAsociadas = ref(1);
const totalPagesAsociadas = ref(1);
const { paginationInfo: paginationInfoAsociadas, setPaginationInfo: setPaginationInfoAsociadas } = usePaginationInfo();
const currentPageDesasociadas = ref(1);

// Commercial search modal variables
const showCommercialSearchModal = ref(false);
const commercialSearchQuery = ref('');
const searchedCommercials = ref([]);
const isSearchingCommercials = ref(false);
const searchTimeout = ref(null);
const totalPagesDesasociadas = ref(1);
const { paginationInfo: paginationInfoDesasociadas, setPaginationInfo: setPaginationInfoDesasociadas } = usePaginationInfo();
const selectedIds = ref([]);
const searchAsociadasRef = ref(null);
const searchDesasociadasRef = ref(null);
// const searchParams = ref({
//   endpoint: '',
//   query: '',
//   filter: '',
//   supply_type: '',
// });
const query = ref('');
// const search = ref(false);
const selectedFilterName = ref({ key: '', label: '' }); 
const isReadOnly = true;
// Las comunidades tienen su propio aviso: que no se puedan cargar (una persona
// sin cuenta cliente, por ejemplo) no puede dejar la ficha en blanco (ADS-0119).
const propertiesError = ref(null);
const fields = [
  { key: "name", label: "Nombre" },
];

// Alcance de Back Office sobre esta ficha (ADS-0119): modifica a las personas
// de las cuentas cliente, no al personal interno de ADS, y no da de baja a
// nadie. El responsable conserva todas las acciones.
const backOffice = isBackOffice();

/**
 * Empresa de la ficha. Si se abre una cuenta cliente, es su propio nombre; si
 * se abre una persona, la cuenta a la que pertenece. Antes mostraba siempre
 * `name`, así que en la ficha de una persona repetía su nombre.
 */
const companyName = computed(() => {
  const data = supplysData.value;
  if (!data) return '-';
  if (targetKind.value === 'account') return data.name ?? '-';
  return data.account || data.company_name || data.client_accounts?.[0]?.name || '-';
});
const ADS_ROLES = ['superadmin', 'admin', 'comercial'];
// Persona de «Usuarios ADS» según la API: el personal interno y los gestores
// del legacy que conservan un perfil de cliente (ADSREC-0008).
const isAdsStaffTarget = computed(() => targetKind.value === 'user' && supplysData.value?.is_ads_staff === true);
const isClientAccountPerson = computed(() => targetKind.value === 'account'
  || !(isAdsStaffTarget.value
    || (supplysData.value?.roles || []).some((role) => ADS_ROLES.includes(role?.name ?? role))));
const canManage = computed(() => !backOffice || isClientAccountPerson.value);
// Perfil con los mismos nombres que la columna «Tipo de cuenta» del listado.
const staffProfile = computed(() => (supplysData.value?.roles || [])
  .map((role) => t(`common.requestTypes.${role?.name ?? role}`))
  .join(', ') || '-');
const canChangeStatus = computed(() => targetKind.value === 'user'
  && (supplysData.value?.can_change_status ?? hasAnyRole(['superadmin'])));
const isInactive = computed(() => supplysData.value?.status === 'inactive');
const primaryAccounts = computed(() => (supplysData.value?.client_accounts || [])
  .filter((account) => Boolean(account.pivot?.is_primary)));
const requiresPrimaryTransfer = computed(() => !isInactive.value && primaryAccounts.value.length > 0);
const isSearchActiveAsociadas = ref(false);
const isSearchActiveDesasociadas = ref(false);

// --- Activate/deactivate user state ---
const showStatusModal = ref(false);
const isChangingStatus = ref(false);
const statusError = ref(null);
const loadingTransferOptions = ref(false);
const transferOptions = ref({});
const selectedReplacements = ref({});
const transfersComplete = computed(() => !requiresPrimaryTransfer.value
  || primaryAccounts.value.every((account) => Number(selectedReplacements.value[account.id]) > 0));



// --- Endpoints dinámicos según rol ---
const role = ref(localStorage.getItem("role"));
const searchEndpointAsociadas = role.value === 'superadmin'
  ? '/property/user/assigned/search'
  : '/property/user/assigned/search';
const searchEndpointDesasociadas = role.value === 'superadmin'
  ? '/property/user/unassigned/search'
  : '/property/user/unassigned/search';


// --- Métodos ---
const getAccountType = () => accountTypeLabel(supplysData.value);

const getUserDetail = async (userId) => {
  loading.value = true;
  error.value = null;
  try {
    // This route always represents a person. Looking up a client account first
    // could open an unrelated account when both tables happened to share an id.
    const response = await axios.get(
      `${import.meta.env.VITE_API_URL}/user/get/${userId}`,
      {
        headers: {
          Accept: 'application/json',
          Authorization: `Bearer ${localStorage.getItem('token')}`,
        },
      }
    );
    targetKind.value = 'user';
    supplysData.value = response.data?.value || null;
    if (!supplysData.value) error.value = "No se encontraron datos para este usuario.";
  } catch (err) {
    error.value = "Error al cargar datos del usuario.";
    console.error(err);
  } finally {
    loading.value = false;
  }
};

// const getAllProperties = async (page = 1, perPage = 20) => {
//   loading.value = true;
//   error.value = null;
//   try {
//     const response = await axios.get(
//       `${import.meta.env.VITE_API_URL}${role.value === 'superadmin' ? '/property/superadmin/list' : '/property/user/list'}`,
//       {
//         headers: {
//           Accept: "application/json",
//           Authorization: `Bearer ${localStorage.getItem("token")}`,
//         },
//         params: { per_page: perPage, page },
//       }
//     );
//     return response.data?.value || null;
//   } catch (err) {
//     error.value = "Error al cargar propiedades.", err;
//     return null;
//   } finally {
//     loading.value = false;
//   }
// };

// --- Eliminar getAllProperties ---

// --- Nueva función para cargar Comunidades iniciales (página 1, query vacía) ---
const fetchInitialProperties = async (type = 'both', page = 1) => {
  // El backend responde 403 a los clientes; no hay nada que cargar.
  if (!isAdsUser) return;
  loading.value = true;
  propertiesError.value = null;
  try {
    if (type === 'associate' || type === 'both') {
      const assignedResponse = await axios.get(
        `${import.meta.env.VITE_API_URL}/property/user/assigned`,
        {
          headers: {
            Accept: "application/json",
            Authorization: `Bearer ${localStorage.getItem("token")}`,
          },
          params: {
            page,
            per_page: 10,
            ...associationParams.value,
          },
        }
      );
      fincaData.value.associate = assignedResponse.data?.value?.data || [];
      totalPagesAsociadas.value = assignedResponse.data?.value?.last_page || 1;
      setPaginationInfoAsociadas(assignedResponse.data?.value);
    }
    if (type === 'disassociate' || type === 'both') {
      const unassignedResponse = await axios.get(
        `${import.meta.env.VITE_API_URL}/property/user/unassigned`,
        {
          headers: {
            Accept: "application/json",
            Authorization: `Bearer ${localStorage.getItem("token")}`,
          },
          params: {
            page,
            per_page: 10,
            ...associationParams.value,
          },
        }
      );
      fincaData.value.disassociate = unassignedResponse.data?.value?.data || [];
      totalPagesDesasociadas.value = unassignedResponse.data?.value?.last_page || 1;
      setPaginationInfoDesasociadas(unassignedResponse.data?.value);
    }
  } catch (err) {
    propertiesError.value = "Error al cargar Comunidades iniciales.";
    console.error(err);
  } finally {
    loading.value = false;
  }
};

// --- Función para obtener Comunidades según búsqueda y paginación ---
const fetchPropertiesBySearch = async (type, page = 1, query = '', filter = '') => {
  loading.value = true;
  propertiesError.value = null;
  try {
    const endpoint = type === 'associate' ? searchEndpointAsociadas : searchEndpointDesasociadas;
    const response = await axios.get(
      `${import.meta.env.VITE_API_URL}${endpoint}`,
      {
        headers: {
          Accept: "application/json",
          Authorization: `Bearer ${localStorage.getItem("token")}`,
        },
        params: {
          page,
          per_page: 10,
          query,
          ...associationParams.value,
          filter,
          search_by: 'name',
        },
      }
    );

    fincaData.value[type] = response.data?.value?.data || [];
    if (type === 'associate') {
      totalPagesAsociadas.value = response.data?.value?.last_page || 1;
      setPaginationInfoAsociadas(response.data?.value);
    } else {
      totalPagesDesasociadas.value = response.data?.value?.last_page || 1;
      setPaginationInfoDesasociadas(response.data?.value);
    }
  } catch (err) {
    propertiesError.value = `Error al buscar Comunidades ${type}.`;
    console.error(err);
  } finally {
    loading.value = false;
  }
};

// --- Modificar fetchAllData para cargar usuario y Comunidades iniciales ---
const fetchAllData = async () => {
  loading.value = true;
  error.value = null;
  propertiesError.value = null;
  await getUserDetail(id);
  await fetchInitialProperties();
  loading.value = false;
};

const handlePageChangeAsociadas = (newPage) => {
  currentPageAsociadas.value = newPage;
  if (isSearchActiveAsociadas.value) {
    if (searchAsociadasRef.value && searchAsociadasRef.value.performSearch) {
      searchAsociadasRef.value.performSearch(newPage);
    }
  } else {
    fetchInitialProperties('associate', newPage);
  }
};

const handlePageChangeDesasociadas = (newPage) => {
  currentPageDesasociadas.value = newPage;
  if (isSearchActiveDesasociadas.value) {
    if (searchDesasociadasRef.value && searchDesasociadasRef.value.performSearch) {
      searchDesasociadasRef.value.performSearch(newPage);
    }
  } else {
    fetchInitialProperties('disassociate', newPage);
  }
};

const handlePageUpdateAsociadas = (page) => {
  currentPageAsociadas.value = page;
  if (searchAsociadasRef.value && searchAsociadasRef.value.performSearch) {
    searchAsociadasRef.value.performSearch(page);
  }
};

const handlePageUpdateDesasociadas = (page) => {
  currentPageDesasociadas.value = page;
  if (searchDesasociadasRef.value && searchDesasociadasRef.value.performSearch) {
    searchDesasociadasRef.value.performSearch(page);
  }
};

// --- Modificar handleSearchResults para actualizar datos y paginación ---
function handleSearchResults(type, results) {
  if (!results?.value?.data) {
    if (type === 'associate') {
      fincaData.value.associate = [];
      totalPagesAsociadas.value = 1;
      currentPageAsociadas.value = 1;
      isSearchActiveAsociadas.value = true;
    } else {
      fincaData.value.disassociate = [];
      totalPagesDesasociadas.value = 1;
      currentPageDesasociadas.value = 1;
      isSearchActiveDesasociadas.value = true;
    }
    return;
  }

  if (type === 'associate') {
    isSearchActiveAsociadas.value = true;
    fincaData.value.associate = results.value.data || [];
    totalPagesAsociadas.value = results.value.last_page || 1;
    setPaginationInfoAsociadas(results.value);
    currentPageAsociadas.value = results.value.current_page || 1;
  } else {
    isSearchActiveDesasociadas.value = true;
    fincaData.value.disassociate = results.value.data || [];
    totalPagesDesasociadas.value = results.value.last_page || 1;
    setPaginationInfoDesasociadas(results.value);
    currentPageDesasociadas.value = results.value.current_page || 1;
  }
  query.value = results.query || '';
  selectedFilterName.value.key = results.filter || '';
}

const loadTransferOptions = async () => {
  if (!requiresPrimaryTransfer.value) return;

  loadingTransferOptions.value = true;
  try {
    const entries = await Promise.all(primaryAccounts.value.map(async (account) => {
      const response = await axios.get(
        `${import.meta.env.VITE_API_URL}/client-account/get/${account.id}`,
        {
          headers: {
            Accept: 'application/json',
            Authorization: `Bearer ${localStorage.getItem('token')}`,
          },
        }
      );
      const candidates = (response.data?.value?.children || []).filter((candidate) =>
        Number(candidate.id) !== Number(id) && !['inactive', 'deleted'].includes(candidate.status)
      );
      return [account.id, candidates];
    }));
    transferOptions.value = Object.fromEntries(entries);
  } catch (err) {
    console.error(err);
    statusError.value = t('user.statusAction.transferLoadError');
  } finally {
    loadingTransferOptions.value = false;
  }
};

const openStatusModal = async () => {
  statusError.value = null;
  transferOptions.value = {};
  selectedReplacements.value = {};
  showStatusModal.value = true;
  await loadTransferOptions();
};

const confirmStatusChange = async () => {
  isChangingStatus.value = true;
  statusError.value = null;
  const nextStatus = isInactive.value ? 'active' : 'inactive';
  const payload = { status: nextStatus };
  if (requiresPrimaryTransfer.value) {
    payload.primary_transfers = primaryAccounts.value.map((account) => ({
      client_account_id: account.id,
      replacement_user_id: selectedReplacements.value[account.id],
    }));
  }
  try {
    const response = await axios.put(
      `${import.meta.env.VITE_API_URL}/user/status/${id}`,
      payload,
      {
        headers: {
          Accept: "application/json",
          Authorization: `Bearer ${localStorage.getItem("token")}`,
        },
      }
    );
    const clientAccounts = nextStatus === 'inactive' && requiresPrimaryTransfer.value
      ? (supplysData.value?.client_accounts || []).map((account) => ({
          ...account,
          pivot: { ...account.pivot, is_primary: false },
        }))
      : supplysData.value?.client_accounts;
    supplysData.value = {
      ...supplysData.value,
      ...(response.data?.value || {}),
      status: nextStatus,
      client_accounts: clientAccounts,
    };
    toast.success(t(nextStatus === 'active' ? 'user.statusAction.activated' : 'user.statusAction.deactivated'));
    showStatusModal.value = false;
  } catch (err) {
    console.error(err);
    const code = err.response?.data?.code;
    const key = code === 'primary_user_transfer_required'
      ? 'user.statusAction.primaryTransferRequired'
      : code === 'invalid_primary_transfer'
        ? 'user.statusAction.invalidTransfer'
        : 'user.statusAction.error';
    statusError.value = t(key);
    toast.error(statusError.value);
  } finally {
    isChangingStatus.value = false;
  }
};

const closeStatusModal = () => {
  showStatusModal.value = false;
  statusError.value = null;
  transferOptions.value = {};
  selectedReplacements.value = {};
};

const sendSetPassword = async () => {
  if (!id) {
    toast.error('ID de usuario no disponible', { position: 'top-right' });
    return;
  }
  try {
    const frontendBaseUrl = import.meta.env.VITE_APP_URL || window.location.origin;
    const resp = await axios.post(
      `${import.meta.env.VITE_API_URL}/user/send-set-password/${id}`,
      {
        reset_url: `${frontendBaseUrl}/set-password`
      },
      {
        headers: {
          Accept: 'application/json',
          Authorization: `Bearer ${localStorage.getItem('token')}`
        }
      }
    );

    if (resp?.data) {
      toast.success(t('admin.messages.passwordEmailSent') || 'Correo de cambio de contraseña enviado', { position: 'top-right' });
    } else {
      toast.error('No se pudo enviar el correo de cambio de contraseña', { position: 'top-right' });
    }
  } catch (err) {
    console.error('Error sending set-password:', err);
    toast.error('Error al enviar la solicitud', { position: 'top-right' });
  }
};

const confirmAndSendSetPassword = async () => {
  const message = t('admin.confirmations.sendPassword');
  const confirmMsg = message || 'Se enviará un correo para cambiar la contraseña. ¿Desea continuar?';

  let proceed = true;
  try {
    proceed = window.confirm(confirmMsg);
  } catch (e) {
      toast.success(t('admin.messages.passwordEmailSent') || 'Correo de cambio de contraseña enviado', { position: 'top-right' });
    proceed = true;
  }

  if (!proceed) return;

  await sendSetPassword();
};

// --- Carga inicial y refresco ---
// const fetchAllData = async () => {
//   loading.value = true;
//   error.value = null;
//   await getUserDetail(id);
//   const propertiesData = await getAllProperties(currentPageDesasociadas.value, 10);
//   if (propertiesData && supplysData.value) {
//     const allProperties = propertiesData.data || [];
//     const associatedProperties = supplysData.value.properties || [];
//     const disassociatedProperties = allProperties.filter(
//       prop => !associatedProperties.some(ap => ap.id === prop.id)
//     );
//     fincaData.value = {
//       associate: associatedProperties,
//       disassociate: disassociatedProperties,
//     };
//     totalPagesDesasociadas.value = propertiesData.last_page;
//   }
//   loading.value = false;
// };


// --- Asociar Comunidades ---
const asociar = async () => {
  if (selectedIds.value.length === 0) return;
  try {
    const params = new URLSearchParams(associationParams.value);
    selectedIds.value.forEach(id => params.append('properties[]', id));
    await axios.post(
      `${import.meta.env.VITE_API_URL}/property/user/assignation?${params.toString()}`,
      {},
      {
        headers: {
          Accept: "application/json",
          Authorization: `Bearer ${localStorage.getItem("token")}`,
          "Content-Type": "application/json"
        }
      }
    );
    await fetchAllData();
    selectedIds.value = [];
  } catch (err) {
    propertiesError.value = "Error al asociar Comunidades.";
    console.error(err);
  }
};

// --- Desasociar Comunidades ---
const desociar = async () => {
  if (selectedIds.value.length === 0) return;
  try {
    const params = new URLSearchParams(associationParams.value);
    selectedIds.value.forEach(id => params.append('properties[]', id));
    await axios.post(
      `${import.meta.env.VITE_API_URL}/property/user/unassignation?${params.toString()}`,
      {},
      {
        headers: {
          Accept: "application/json",
          Authorization: `Bearer ${localStorage.getItem("token")}`,
          "Content-Type": "application/json"
        },
      }
    );
    await fetchAllData();
    selectedIds.value = [];
  } catch (err) {
    propertiesError.value = "Error al desasociar Comunidades.";
    console.error(err);
  }
};

function handleSearchError(err) {
  propertiesError.value = "Error en la búsqueda.";
  console.error(err);
}

function handleSelectedFilter(filter) {
  selectedFilterName.value = filter || { key: 'name', label: 'Nombre' };
}
function resetSearch(type) {
  if (type === 'associate') {
    isSearchActiveAsociadas.value = false;
    fetchInitialProperties('associate', 1);
    currentPageAsociadas.value = 1;
  } else {
    isSearchActiveDesasociadas.value = false;
    fetchInitialProperties('disassociate', 1);
    currentPageDesasociadas.value = 1;
  }
}

// Commercial search modal functions
const openCommercialSearchModal = () => {
  showCommercialSearchModal.value = true;
  commercialSearchQuery.value = '';
  searchedCommercials.value = [];
};

const closeCommercialSearchModal = () => {
  showCommercialSearchModal.value = false;
  commercialSearchQuery.value = '';
  searchedCommercials.value = [];
  isSearchingCommercials.value = false;
  if (searchTimeout.value) {
    clearTimeout(searchTimeout.value);
    searchTimeout.value = null;
  }
};

const searchCommercials = async () => {
  if (!commercialSearchQuery.value.trim()) {
    searchedCommercials.value = [];
    return;
  }

  // Clear previous timeout
  if (searchTimeout.value) {
    clearTimeout(searchTimeout.value);
  }

  // Set loading state
  isSearchingCommercials.value = true;

  // Debounce search
  searchTimeout.value = setTimeout(async () => {
    try {
      const response = await axios.get(
        `${import.meta.env.VITE_API_URL}/user/commercial-candidates`,
        {
          params: {
            query: commercialSearchQuery.value.trim(),
          },
          headers: {
            Accept: "application/json",
            Authorization: `Bearer ${localStorage.getItem("token")}`,
          },
        }
      );

      const commercialsPage = response.data?.value;
      searchedCommercials.value = Array.isArray(commercialsPage?.data) ? commercialsPage.data : [];
    } catch (error) {
      console.error("Error searching commercials:", error);
      searchedCommercials.value = [];
      toast.error("Error al buscar comerciales");
    } finally {
      isSearchingCommercials.value = false;
    }
  }, 300); // 300ms debounce
};

const selectCommercial = async (commercial) => {
  try {
    const response = await axios.put(
      `${import.meta.env.VITE_API_URL}/user/update/${id}`,
      { comercial: commercial.name, 
        father: commercial.id
       },
      {
        headers: {
          Accept: "application/json",
          Authorization: `Bearer ${localStorage.getItem("token")}`,
        },
      }
    );

    if (response.data?.value) {
      supplysData.value.assigned_commercial = commercial;
      supplysData.value.commercial = commercial.name;
      toast.success("Comercial asignado actualizado con éxito");
      closeCommercialSearchModal();
    } else {
      toast.error("No se pudo actualizar el comercial asignado");
    }
  } catch (error) {
    console.error("Error updating assigned commercial:", error);
    toast.error("Error al actualizar el comercial asignado");
  }
};

// function handleSelectedFilter(filter) {
//   // Puedes guardar el filtro si lo necesitas
// }

// const handlePageChangeAsociadas = (newPage) => {
//   currentPageAsociadas.value = newPage;
//   fetchAllData(newPage);
// };

// const handlePageChangeDesasociadas = (newPage) => {
//   currentPageDesasociadas.value = newPage;
//   fetchAllData(newPage);
// };

// --- Montaje inicial ---
onMounted(async () => {
  await getUserDetail(id);
  await fetchInitialProperties('both', 1);
});


</script>

<style scoped>
.grid-container {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(200px, 1fr));
}
</style>
